import * as Tabs from '@radix-ui/react-tabs';

import styles from './Tabs.module.scss';

const Root = ({ className, children, ...props }: Tabs.TabsProps) => (
  <Tabs.Root className={styles['tab-root']} {...props}>
    {children}
  </Tabs.Root>
);

Root.displayName = 'TabsRoot';

const List = ({ className, children, ...props }: Tabs.TabsListProps) => (
  <Tabs.List className={styles['tab-list']} {...props}>
    {children}
  </Tabs.List>
);

List.displayName = 'TabsList';

const Trigger = ({ className, value, ...props }: Tabs.TabsTriggerProps) => (
  <Tabs.Trigger className={styles['tab-trigger']} value={value} {...props} />
);

Trigger.displayName = 'TabsTrigger';

const Content = ({ className, value, ...props }: Tabs.TabsContentProps) => (
  <Tabs.Content className={className} value={value} {...props} />
);

Content.displayName = 'TabsContent';

export { Root, Content, List, Trigger };
